module.exports = __webpack_public_path__ + "assets/img/nh1.d309e2cc.jpg";